import { Inject, Injectable } from '@angular/core';
import { ENV, IEnvironment } from 'env/config';

import { DataService } from '../http/dataService';
import { CentralApis } from '../interfaces/internal';
import { ISalesEvent, SalesEvent } from '../models/salesEvent.model';
import { Repository } from './repository';

import { Service } from '../entity';

@Service({
  api: 'event',
  model: SalesEvent,
})
@Injectable({ providedIn: 'root' })
export class SalesEventService extends Repository<SalesEvent> {
  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: (env.api.backend.central.endpoint as CentralApis).territory,
    });
  }

  createFromDTO(item: ISalesEvent): SalesEvent {
    return SalesEvent.createFromDTO(item);
  }
}
